import { render, staticRenderFns } from "./BuildingMaterialsAddView.vue?vue&type=template&id=7bc6c866&scoped=true&"
import script from "./BuildingMaterialsAddView.vue?vue&type=script&lang=js&"
export * from "./BuildingMaterialsAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6c866",
  null
  
)

export default component.exports